import { render, staticRenderFns } from "./CreatorShopProductsTab.vue?vue&type=template&id=1deaba8e"
import script from "./CreatorShopProductsTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreatorShopProductsTab.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopTrendingProductSlidegroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/trending-product/TrendingProductSlidegroup.vue').default,CCol: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CCol.vue').default,CreatorShopGiftGuideSlideGroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/gift-guides/GiftGuideSlideGroup.vue').default,SplitTest: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/SplitTest.vue').default,CreatorShopProductSetSlidegroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/product-set/ProductSetSlidegroup.vue').default,CreatorShopProductFeed: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/product-feed/ProductFeed.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default,CContainer: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CContainer.vue').default})
